var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.hierachies),function(summary,idx){return _c('iv-cell-single-hierachy',_vm._b({key:idx,staticClass:"cell-hierachy"},'iv-cell-single-hierachy',{ ..._vm.$attrs, ..._vm.$props, summary, value: _vm.value },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }